var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MyModal",
    {
      style: { top: "115px", right: "50px", left: "unset" },
      attrs: { title: "容量规划", width: "454px", height: "auto" },
      on: { closeClick: _vm.handleCloseModalClick }
    },
    [
      _c("div", { staticClass: "my-face-content" }, [
        _c("div", { staticClass: "form-area" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "row-item" }, [
              _c("div", { staticClass: "key" }, [
                _c("span", [_vm._v("面积")]),
                _vm._v(" :")
              ]),
              _c(
                "div",
                { staticClass: "value" },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.windSelectionInfo.area || "-") + " k㎡")
                  ])
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row-item" }, [
              _c("div", { staticClass: "key" }, [
                _c("span", [_vm._v("容量")]),
                _vm._v(" :")
              ]),
              _c(
                "div",
                { staticClass: "value" },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.windSelectionInfo.cap || "-") + " MW")
                  ])
                ],
                1
              )
            ])
          ]),
          _vm.advanced
            ? _c("div", [
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "key" }, [_vm._v("最低风速")]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("StandInput", {
                        attrs: { onlyNumber: true, unit: "m/s" },
                        model: {
                          value: _vm.windSelectionInfo.avgSpeedYear,
                          callback: function($$v) {
                            _vm.$set(_vm.windSelectionInfo, "avgSpeedYear", $$v)
                          },
                          expression: "windSelectionInfo.avgSpeedYear"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "key" }, [_vm._v("最高海拔")]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("StandInput", {
                        attrs: { onlyNumber: true, precision: 1, unit: "m" },
                        model: {
                          value: _vm.windSelectionInfo.altitudeTo,
                          callback: function($$v) {
                            _vm.$set(_vm.windSelectionInfo, "altitudeTo", $$v)
                          },
                          expression: "windSelectionInfo.altitudeTo"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "form-item" }, [
                  _c("div", { staticClass: "key" }, [_vm._v("最大坡度")]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("StandInput", {
                        attrs: { onlyNumber: true, unit: "%" },
                        model: {
                          value: _vm.windSelectionInfo.slopeTo,
                          callback: function($$v) {
                            _vm.$set(_vm.windSelectionInfo, "slopeTo", $$v)
                          },
                          expression: "windSelectionInfo.slopeTo"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e()
        ]),
        _vm.advanced
          ? _c("div", { staticClass: "lx-limit-area" }, [
              _c("div", { staticClass: "my-title" }, [
                _vm._v(" 限制区域 "),
                _c("i", {
                  class: [
                    "el-icon-circle-plus-outline",
                    {
                      "is-active": _vm.toolUIStatus.lxLimitAdd
                    }
                  ],
                  on: {
                    click: () => {
                      _vm.handleLimitClick()
                    }
                  }
                })
              ]),
              _c(
                "div",
                { staticClass: "area-content" },
                _vm._l(_vm.exclusiveList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "depoly-content-item" },
                    [
                      _c("el-tag", [
                        _vm._v(" 限制区域" + _vm._s(Number(index) + 1))
                      ]),
                      _c("div", { staticClass: "btns" }, [
                        _c("i", {
                          class: [
                            "el-icon-view",
                            {
                              "is-active": item.isShow
                            }
                          ],
                          on: {
                            click: function($event) {
                              return _vm.handleViewClick(item, index)
                            }
                          }
                        }),
                        _c("i", {
                          staticClass: "el-icon-delete",
                          on: {
                            click: function($event) {
                              return _vm.handleDelLimitClick(item, index)
                            }
                          }
                        })
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            ])
          : _vm._e(),
        _vm.advanced
          ? _c(
              "div",
              { staticClass: "btn-wrapper" },
              [
                _c(
                  "ct-button",
                  { attrs: { type: "primary", btnClick: _vm.handleConfirm } },
                  [_vm._v("开始规划")]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }